/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { PersonalDataErrors, UpdateProfileActionTypes, UpdateProfileActions } from './types';
import { validatePersonalData } from './validation';

interface InitialUpdateProfileState {
  loading: boolean;
  error?: Error;
  success?: boolean;
  personalData: {
    pin: string;
    documentNumber: string;
    front: string;
    back: string;
    selfie: string;
  };
  validationErrors: PersonalDataErrors;
  isValid: boolean;
}

const initialUpdateProfileState: InitialUpdateProfileState = {
  loading: false,
  error: undefined,
  success: false,
  personalData: {
    pin: '',
    documentNumber: '',
    front: '',
    back: '',
    selfie: '',
  },
  validationErrors: {},
  isValid: false,
};

export function updateProfileReducer(
  state = initialUpdateProfileState,
  action: UpdateProfileActions,
): InitialUpdateProfileState {
  switch (action.type) {
    case UpdateProfileActionTypes.UPDATE_PROFILE_REQUEST:
      return update(state, {
        loading: { $set: true },
        error: { $set: undefined },
        success: { $set: false },
      });
    case UpdateProfileActionTypes.UPDATE_PROFILE_SUCCESS:
      return update(state, {
        loading: { $set: false },
        error: { $set: undefined },
        success: { $set: true },
      });
    case UpdateProfileActionTypes.UPDATE_PROFILE_FAILURE:
      return update(state, {
        loading: { $set: false },
        error: { $set: action.error },
        success: { $set: false },
      });
    case UpdateProfileActionTypes.UPDATE_PROFILE_RESET_ERROR:
      return update(state, {
        error: { $set: undefined },
      });
    case UpdateProfileActionTypes.UPDATE_PROFILE_RESET:
      return initialUpdateProfileState;
    case UpdateProfileActionTypes.UPDATE_PROFILE_FIELDS: {
      const merged = { ...state.personalData, ...action.fields };
      const validationErrors = validatePersonalData(merged);

      return update(state, {
        personalData: { $merge: action.fields },
        validationErrors: { $set: validationErrors },
        isValid: { $set: Object.keys(validationErrors).length === 0 },
      });
    }
    default:
      return state;
  }
}
